import { IBoundedBy } from '../../types/location';
import { prepareBoundedByCorner } from './prepareBoundedByCorner';
import { IBoundedBySchema } from '../../repositories/geo-temp-layer/entities/catalog_item/BoundedBySchema';

export const prepareBoundedBy = ({ lowerCorner, upperCorner }: IBoundedBySchema): IBoundedBy => {
  return {
    lowerCorner: prepareBoundedByCorner(lowerCorner),
    upperCorner: prepareBoundedByCorner(upperCorner),
  };
};
